import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { Utils } from '../../../../Utils/utils';
import { ApiService } from '../../../../core/services/api.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { DOCUMENT } from '@angular/common';
import { FieldValue, ServiceNameAr, ServiceNameEn, UserType } from '../../../../shared/constants/services.enum';
import { serviceDataArabic } from '../../../../data/DCGJProcessArabic';
import { serviceData } from '../../../../data/DCGJProcess';
import { Subscription } from 'rxjs';
import { AccountManagementSharedService } from '../../account-management/services/account-management-shared.service';
import { NotificationHistoryService } from '../../../../shared/services/notification-history.service';
import { NotificationHistoryViewModel } from '../../../../shared/models/notification-history.model';
@Component({
  selector: 'app-right-sidebar',
  imports: [CommonModule, TranslateModule, ButtonComponent, RouterLink],
  templateUrl: './right-sidebar.component.html',
  styleUrl: './right-sidebar.component.scss'
})
export class RightSidebarComponent implements OnChanges, OnDestroy {
  servicesMenuGroup: any = [];
  @Input() platinumMember: any = "";
  expandServicesList: boolean = false;
  notifications: NotificationHistoryViewModel[] = [];
  notificationsLoading: boolean = false;
  lang: string = "en";
  suggestedServices: any[] = [
    {
      title: "MENU_CERTIFICATE_OF_ORIGIN", "text": "SR_ISSUE_COO",
      accessFlagKey: "DC COO Services Flag",
      id: "coo"
    },
    {
      title: "MENU_ATA", "text": "SR_ATA_CARNET_NEW",
      accessFlagKey: "DC ATA Services Flag",
      id: "ata-carnet-registration"
    }
  ];
  isOpenPlatinumMemDetail: boolean = true;
  accountCSN: string = "";
  primaryAccount: any = null;
  private primaryAccountSubscription: Subscription | null = null;
  private userProfileSubscription: Subscription | null = null;
  private navigationSubscription: Subscription | null = null;
  private loginName: string;
  private lastServiceAccessAccountId: string = '';
  private lastPendingActionsAccountCSN: string = '';
  private lastNotificationLogin: string = '';
  numberOfUnreadNotifications: number = 5;

  constructor(
    private api: ApiService,
    private sharedService: SharedService,
    private router: Router,
    private notificationHistoryService: NotificationHistoryService,
    private accountManagementSharedService: AccountManagementSharedService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.loginName = this.sharedService.getUserProfile()?.['Login Name'] ?? '';
    this.lang = this.sharedService.getCurrentLang() || "en";
    this.primaryAccountSubscription = this.sharedService.primaryAccount$.subscribe(
      (account) => {
        this.handlePrimaryAccountChange(account);
      }
    );
    this.userProfileSubscription = this.sharedService.userProfile$.subscribe((profile) => {
      const nextLoginName = profile?.['Login Name'] ?? '';
      if (nextLoginName === this.loginName) {
        return;
      }
      this.loginName = nextLoginName;
      this.lastNotificationLogin = '';
      this.loadUnreadNotifications();
    });
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.urlAfterRedirects === `/${RoutesPath.DASHBOARD}`) {
        this.loadUnreadNotifications(true);
      }
    });
    if (this.loginName) {
      this.loadUnreadNotifications(true);
    }
  }

  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    const accountId = this.sharedService.getCsnAccountId('id');
    if (accountId && accountId !== this.lastServiceAccessAccountId) {
      this.getUserAllowedServices();
    }
  }
  serviceAccessFlags: any = [];
  getUserAllowedServices() {
    const accountId = this.sharedService.getCsnAccountId('id');
    if (!accountId || accountId === this.lastServiceAccessAccountId) {
      return;
    }
    this.lastServiceAccessAccountId = accountId;
    const requestPayload = {
      body: {
        ProcessName: 'DC User Favorite Services WF',
        'DC Channel': this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        'DC Method': 'GETFAVOURITES',
        'Account Id': accountId
      }
    };
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.RUN_PROCESS, requestPayload)
      .subscribe({
        next: (response: any) => {
          this.serviceAccessFlags = response || {};
          this.sharedService.setServiceAccessFlags(this.serviceAccessFlags);
        }
      })

    // this.accountManagementSharedService
    // .getUserAccessDetails(this.sharedService.getCsnAccountId('csn'), this.loginName)
    // .subscribe({
    //   next: (response: any) => {
    //     if (response['Error Code'] == "" && response['Error Message'] == "") {
    //       const detail = response?.SiebelMessage?.["User Details"];
    //       const userAccess = detail?.['User Access Details'];
    //       this.serviceAccessFlags = userAccess || {};
    //       this.sharedService.setServiceAccessFlags(userAccess);

    //     }
    //   }
    // });
  }

  // This method is used to build from service data
  private buildFromServiceData() {
    const groupsMap = new Map<string, any>();
    const source: any = this.lang === 'ar' ? serviceDataArabic : serviceData;
    const items = source?.Items || [];
    for (const it of items) {
      if (it?.Visible === false) continue; // respect visibility flag
      const [groupRaw, nameRaw] = String(it.SRType || '').split('||');
      const groupName = (groupRaw || '').trim();
      const serviceName = (nameRaw || '').trim();
      if (!groupName || !serviceName) continue;
      if (!groupsMap.has(groupName)) {
        groupsMap.set(groupName, {
          groupName,
          isOpen: false,
          active: true,
          description: '',
          parentServiceName: this.getParentServiceName(it),
          services: [] as any[],
        });
      }
      const group = groupsMap.get(groupName)!;
      // if (!this.primaryAccount?.['DC HI Start Date'] && it.id === 'mrm-award') continue; // Hide MRM service not HI start date
      group.services.push({
        id: it.id,
        serviceName,
        routerLink: it.id,
        favourite: false,
        active: true,
        description: it.PreText || '',
        serviceNameTranslation: it.serviceNameForList,
        ...it
      });
    }
    // Make the first group open by default
    // drop empty groups
    let groups = Array.from(groupsMap.values()).filter(
      (g) => (g.services?.length ?? 0) > 0
    );
    // Move Membership Services group to the front
    const idx = groups.findIndex((g) => g.groupName === 'Membership');
    if (idx > 0) {
      const [ms] = groups.splice(idx, 1);
      groups = [ms, ...groups];
    }
    // ensure only first is open by default
    groups.forEach((g, i) => (g.isOpen = i === 0));
    return groups;
  }

  private getParentServiceName(service: any): string {
    const parentKey = service?.parentServiceKey as keyof typeof ServiceNameEn | undefined;
    const lang = this.sharedService.getCurrentLang()
      || localStorage.getItem('selectedLang')
      || this.lang
      || 'en';
    if (parentKey) {
      if (lang === 'ar') {
        return (ServiceNameAr as any)[parentKey] || '';
      }
      return (ServiceNameEn as any)[parentKey] || '';
    }
    return '';
  }

  // This method is used to groups filtered
  get groupsFiltered() {
    let userType = this.sharedService.getPrimaryAccount()['Account Type Code'];

    const filterService = (s: any) => {
      const serviceName = (s.serviceName || '').toLowerCase();

      // Exclude "Personal Effects" for Members
      if (userType === UserType.MEMBER && serviceName === 'personal effects') {
        return false;
      }

      // Exclude COO-related services for non-Members
      if (
        userType !== UserType.MEMBER &&
        (serviceName === 'issue new coo' ||
          serviceName === 'issue gsp certificate' ||
          s.id === 'coo-amendment')
      ) {
        return false;
      }
      return true;
    };

    const groups: any[] = [];
    for (const g of this.servicesMenuGroup || []) {
      g.visibleServices = (g.services || []).filter(filterService);

      if ((g.visibleServices?.length ?? 0) > 0) {
        groups.push(g);
      }
    }

    return groups;
  }

  // This method is used to apply service
  applyService() {
    this.expandServicesList = !this.expandServicesList;
  }

  toggleServiceGroup(targetGroup: any): void {
    for (const group of this.groupsFiltered || []) {
      group.isOpen = group === targetGroup ? !group.isOpen : false;
    }
  }

  viewPlatinumDetails() {
    if (!this.accountCSN) {
      return;
    }
    this.router.navigate(
      ['/', RoutesPath.MEMBERSHIP.DETAIL, this.accountCSN],
      { queryParams: { tab: 'platinum' } }
    );
  }

  // This method is used to toggle platinum details
  togglePlatinumMemDetail(): void {
    this.isOpenPlatinumMemDetail = !this.isOpenPlatinumMemDetail;
  }

  // This method is used to tier gradient
  get tierGradient(): string {
    switch ('Platinum') {
      case 'Platinum':
        return 'bg-gradient-to-r from-[#FFF9C7] via-[#F7EB7A] to-[#E2CD45]';
      default:
        return 'bg-gradient-to-r from-amber-100 to-amber-300';
    }
  }


  pendingActions: any[] = [];
  pendingCases: any[] = [];
  pendingActionsCount: number = 0;
  pendingActionsLoading: boolean = false;
  pendingActionsExpanded: boolean = false;

  // This method is used to get pending actions list
  getPendingActions() {
    this.pendingActions = [];
    this.pendingCases = [];
    this.pendingActionsCount = 0;
    this.pendingActionsExpanded = false;
    if (!this.accountCSN) {
      return;
    }
    if (this.accountCSN === this.lastPendingActionsAccountCSN) {
      return;
    }
    this.lastPendingActionsAccountCSN = this.accountCSN;
    const requestPayload = {
      body: {
        ProcessName: 'DC Community Portal Pending SR Query Wrapper WF',
        DCMethod: 'PENDING_SR_CASE_COUNT',
        DCLanguage: this.lang === 'ar' ? 'ARA' : 'ENU',
        DCLoginName: this.loginName || '',
        DCIncomingHierarchy: {
          MessageId: Utils.generateUniqueId(),
          IntObjectName: 'DC Community Portal SR IO',
          MessageType: 'Integration Object',
          IntObjectFormat: 'Siebel Hierarchical',
          'ListOfDC Community Portal SR IO': {
            'DC Community Portal SR': {
              CSN: this.accountCSN
            }
          }
        }
      }
    };
    this.pendingActionsLoading = true;
    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.QUERY_PENDING_SR_CASE_DETAILS,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response?.['Error Code'] == null) {
          const srCount = Number(response?.DCSRPendingCount ?? 0);
          const caseCount = Number(response?.DCCasePendingCount ?? 0);
          const safeSrCount = Number.isFinite(srCount) ? srCount : 0;
          const safeCaseCount = Number.isFinite(caseCount) ? caseCount : 0;
          this.pendingActionsCount = safeSrCount + safeCaseCount;
          this.pendingActions = Utils.checkIsArray(
            response?.DCSRSiebelMessage?.['DC Community Portal ATA SR']
          );
          this.pendingCases = Utils.checkIsArray(
            response?.DCCaseSiebelMessage?.['DC Community Portal Mediation Cases']
          );
          // this.pendingActionsExpanded = this.pendingActionsCount > 1;
        }
      },
      error: () => {
        this.pendingActionsCount = 0;
        this.pendingActions = [];
        this.pendingCases = [];
      },
      complete: () => {
        this.pendingActionsLoading = false;
      }
    });
  }

  togglePendingActions(): void {
    if (this.pendingActionsCount > 1) {
      this.pendingActionsExpanded = !this.pendingActionsExpanded;
    }
  }

  // This method is used to open pending action
  openPendingAction(pendingAction: any): void {
    const status = (pendingAction?.Status || '').toString().trim();
    if (!status) {
      this.gotoApplications();
      return;
    }
    this.router.navigate(
      [RoutesPath.APPLICATIONS],
      { queryParams: { action: status } }
    );
  }
  // This method is used to open pending case
  openPendingCase(pendingCase: any): void {
    let ref = (pendingCase?.['DC Complainant UniqueID'] || '').toString().trim();
    const caseNo = (pendingCase?.['Serial Number'] || '').toString().trim();
    if (!caseNo) {
      return;
    }
    if (pendingCase['DC SR CreatedBy Login'] == this.loginName) {
      ref = pendingCase['DC Complainant UniqueID'].toString().trim();
    } else {
      ref = pendingCase['DC Respondant UniqueID'].toString().trim();
    }
    if (!ref) {
      return;
    }
    this.router.navigate(
      [`${RoutesPath.SERVICE}/${RoutesPath.PUBLIC.MEDIATION_CASE_DETAIL}`],
      { queryParams: { ref, case: caseNo } }
    );
  }

  // This method is used to goto applications
  gotoApplications() {
    if (this.pendingActionsCount < 1) {
      return;
    }
    this.router.navigate(
      [RoutesPath.APPLICATIONS],
      { queryParams: { action: "ac" } }
    );
  }

  getIconPath(icon: string): string {
    const fileName = icon?.split('/').pop() ?? icon;
    const isPlatinumTheme = this.document?.body?.classList.contains('platinum-theme');
    return isPlatinumTheme ? `/icons/platinum/${fileName}` : `/icons/${icon}`;
  }

  get isPlatinumTheme(): boolean {
    return this.document?.body?.classList.contains('platinum-theme') ?? false;
  }

  startService(s: any) {
    if (!s?.id) return;
    if (!this.sharedService.isServiceAllowed(s, this.serviceAccessFlags)) {
      this.sharedService.toastMessage('ERROR', 'SERVICE_NOT_AUTHORIZED', 'error');
      return;
    }
    this.router.navigate([RoutesPath.SERVICE + '/' + s.id]);
  }

  private handlePrimaryAccountChange(account: any): void {
    this.primaryAccount = account;
    const nextAccountCSN = account?.CSN || '';
    const nextAccountId = account?.Id || '';
    const accountChanged =
      nextAccountCSN !== this.lastPendingActionsAccountCSN ||
      nextAccountId !== this.lastServiceAccessAccountId;
    this.accountCSN = nextAccountCSN;
    this.servicesMenuGroup = this.buildFromServiceData();
    if (accountChanged) {
      this.getUserAllowedServices();
      this.getPendingActions();
    }
  }

  getNotificationPreview(notification: NotificationHistoryViewModel): string {
    return notification.body || notification.heading || '';
  }

  getNotificationTime(createdOnDate: Date | null, fallback: string): string {
    if (!createdOnDate) {
      return fallback;
    }

    const diffMs = Date.now() - createdOnDate.getTime();
    if (diffMs < 0) {
      return this.formatDisplayDate(createdOnDate);
    }

    const formatter = new Intl.RelativeTimeFormat(
      this.lang === 'ar' ? 'ar' : 'en',
      { numeric: 'auto' }
    );

    const minutes = Math.floor(diffMs / (1000 * 60));
    if (minutes < 1) {
      return formatter.format(0, 'minute');
    }
    if (minutes < 60) {
      return formatter.format(-minutes, 'minute');
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return formatter.format(-hours, 'hour');
    }

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    const startOfCreatedDay = new Date(createdOnDate);
    startOfCreatedDay.setHours(0, 0, 0, 0);
    const dayDiff = Math.round(
      (startOfToday.getTime() - startOfCreatedDay.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (dayDiff <= 1) {
      return formatter.format(-dayDiff, 'day');
    }

    return this.formatDisplayDate(createdOnDate);
  }

  private formatDisplayDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  private loadUnreadNotifications(forceRefresh: boolean = false): void {
    const loginName = this.sharedService.getUserProfile()?.['Login Name'] ?? '';
    if (!loginName) {
      this.notifications = [];
      this.lastNotificationLogin = '';
      return;
    }

    if (!forceRefresh && loginName === this.lastNotificationLogin && this.notifications.length > 0) {
      return;
    }

    this.lastNotificationLogin = loginName;
    this.notificationsLoading = true;
    this.notificationHistoryService
      .getUnreadNotificationViewModels(loginName, this.lang, this.numberOfUnreadNotifications)
      .subscribe({
        next: (response) => {
          this.notifications = response.notifications;
          this.notificationsLoading = false;
        },
        error: () => {
          this.notifications = [];
          this.notificationsLoading = false;
          this.lastNotificationLogin = '';
        }
      });
  }

  ngOnDestroy(): void {
    this.primaryAccountSubscription?.unsubscribe();
    this.userProfileSubscription?.unsubscribe();
    this.navigationSubscription?.unsubscribe();
  }
}
